module.exports = __webpack_public_path__ + "static/media/easy.32bfe850.svg";